<template>
  <div class="ns-wrapper">
    <h2 class="ns-title">Importa forniture non sospendibili (XLSX)</h2>

    <div class="ns-card">
      <div class="ns-row">
        <label class="ns-label">File (.xlsx)</label>
        <input
          class="ns-input"
          type="file"
          accept=".xlsx"
          @change="onFileChange"
        />
      </div>

      <div class="ns-actions">
        <button
          class="ns-btn"
          :disabled="loading || !file"
          @click="upload"
          type="button"
        >
          {{ loading ? 'Caricamento...' : 'Carica file' }}
        </button>

        <button
          class="ns-btn ns-btn-secondary"
          :disabled="loading"
          @click="reset"
          type="button"
        >
          Reset
        </button>
      </div>

      <div v-if="error" class="ns-alert ns-alert-error">
        {{ error }}
      </div>

      <div v-if="success" class="ns-alert ns-alert-success">
        {{ success }}
      </div>

      <div v-if="result" class="ns-result">
        <div class="ns-result-title">Risultato</div>
        <pre class="ns-pre">{{ result }}</pre>
      </div>
    </div>
  </div>
</template>

<script setup>
import { getCurrentInstance, ref } from 'vue';
import NonSospendibiliService from '@/services/ask-pratiche/sospensioni/nonSospendibiliService';

const { proxy } = getCurrentInstance();

const file = ref(null);
const loading = ref(false);
const error = ref('');
const success = ref('');
const result = ref(null);

// Istanza del service usando http/eventBus globali
const nonSospendibiliService = new NonSospendibiliService(proxy.$http, proxy.$eventBus);

const onFileChange = (e) => {
  error.value = '';
  success.value = '';
  result.value = null;

  const f = e.target.files && e.target.files[0] ? e.target.files[0] : null;
  file.value = f;
};

const reset = () => {
  file.value = null;
  loading.value = false;
  error.value = '';
  success.value = '';
  result.value = null;

  const input = document.querySelector('.ns-input');
  if (input) {
    input.value = '';
  }
};

const upload = async () => {
  error.value = '';
  success.value = '';
  result.value = null;

  if (!file.value) {
    error.value = 'Seleziona un file .xlsx prima di caricare.';
    return;
  }

  loading.value = true;

  try {
    const response = await nonSospendibiliService.importaXlsx(file.value);
    result.value = response.data;
    success.value = 'Upload completato.';
  } catch (err) {
    const msg = err?.response?.data?.message
      || (err?.response?.status === 422 ? 'File non valido (controlla estensione e dimensione).' : null)
      || err?.message
      || 'Errore durante il caricamento.';

    error.value = msg;
    result.value = err?.response?.data || null;
  } finally {
    loading.value = false;
  }
};
</script>

<style scoped>
.ns-wrapper {
  max-width: 760px !important;
  margin: 0 auto !important;
  padding: 24px !important;
}

.ns-title {
  margin: 0 0 16px 0 !important;
  font-size: 20px !important;
  font-weight: 700 !important;
}

.ns-card {
  border: 1px solid rgba(0, 0, 0, 0.12) !important;
  border-radius: 12px !important;
  padding: 16px !important;
  background: #fff !important;
}

.ns-row {
  display: flex !important;
  flex-direction: column !important;
  gap: 8px !important;
  margin-bottom: 14px !important;
}

.ns-label {
  font-size: 13px !important;
  font-weight: 600 !important;
}

.ns-input {
  width: 100% !important;
  padding: 10px !important;
  border: 1px solid rgba(0, 0, 0, 0.2) !important;
  border-radius: 10px !important;
  background: #fff !important;
}

.ns-actions {
  display: flex !important;
  gap: 10px !important;
  align-items: center !important;
  margin-top: 8px !important;
}

.ns-btn {
  border: 0 !important;
  border-radius: 10px !important;
  padding: 10px 14px !important;
  font-weight: 700 !important;
  cursor: pointer !important;
  background: #111 !important;
  color: #fff !important;
}

.ns-btn:disabled {
  opacity: 0.6 !important;
  cursor: not-allowed !important;
}

.ns-btn-secondary {
  background: #e9e9e9 !important;
  color: #111 !important;
}

.ns-alert {
  margin-top: 14px !important;
  padding: 12px !important;
  border-radius: 10px !important;
  font-size: 13px !important;
  line-height: 18px !important;
}

.ns-alert-error {
  background: rgba(220, 38, 38, 0.12) !important;
  border: 1px solid rgba(220, 38, 38, 0.25) !important;
  color: #b91c1c !important;
}

.ns-alert-success {
  background: rgba(22, 163, 74, 0.12) !important;
  border: 1px solid rgba(22, 163, 74, 0.25) !important;
  color: #166534 !important;
}

.ns-result {
  margin-top: 14px !important;
}

.ns-result-title {
  font-size: 13px !important;
  font-weight: 700 !important;
  margin-bottom: 8px !important;
}

.ns-pre {
  margin: 0 !important;
  padding: 12px !important;
  border-radius: 10px !important;
  background: #0b1020 !important;
  color: #e5e7eb !important;
  font-size: 12px !important;
  overflow: auto !important;
}
</style>
